import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

type ToastItem = { id: number; message: string };

const ToastContext = createContext<(message: string) => void>(() => {});

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const showToast = useCallback((message: string) => {
    const id = Date.now() + Math.floor(Math.random() * 1000);
    setToasts((prev) => [...prev, { id, message }]);
    window.setTimeout(() => {
      setToasts((prev) => prev.filter((item) => item.id !== id));
    }, 2200);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed bottom-6 left-1/2 z-[100] flex -translate-x-1/2 flex-col items-center gap-2 pointer-events-none px-4">
        {toasts.map((item) => (
          <div
            key={item.id}
            style={{ animation: 'toastIn .25s ease' }}
            className="rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50"
          >
            {item.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}